export const REQUEST_ADDRESS_DATA = 'REQUEST_ADDRESS_DATA'
export const SET_ADDRESS_STATE = 'SET_ADDRESS_STATE'
export const SET_ADDRESS_DATA = 'SET_ADDRESS_DATA'
export const SET_ADDRESS_FORM = 'SET_ADDRESS_FORM'
export const SET_ADDRESS_DEFAULT = 'SET_ADDRESS_DEFAULT'
export const SET_ADDRESS_SELECTED = 'SET_ADDRESS_SELECTED'
